import { render } from "./SuccessView.vue?vue&type=template&id=2f4ab642&scoped=true"
import script from "./SuccessView.vue?vue&type=script&lang=js"
export * from "./SuccessView.vue?vue&type=script&lang=js"

import "./SuccessView.vue?vue&type=style&index=0&id=2f4ab642&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4ab642"]])

export default __exports__